import { render, staticRenderFns } from "./MetabaseDashboard.vue?vue&type=template&id=6d8d42ae&scoped=true&"
import script from "./MetabaseDashboard.vue?vue&type=script&lang=js&"
export * from "./MetabaseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MetabaseDashboard.vue?vue&type=style&index=0&id=6d8d42ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8d42ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
